// ---------------------------------------------------------------------------
// Ce scrie fiecare pagină în capul documentului.
//
// Fiind o aplicație cu o singură pagină HTML, toate rutele porneau cu titlul și
// descrierea din `index.html` — șase adrese diferite care se prezentau identic
// în rezultatele căutării și în orice previzualizare de link.
//
// Adresa e apex-ul, nu www: certificatul TLS acoperă doar `quantikflow.com`,
// deci `www.quantikflow.com` nu se încarcă deloc. Dacă se emite un certificat
// care acoperă și www, se schimbă o singură linie aici.
// ---------------------------------------------------------------------------

export const SITE_URL = 'https://quantikflow.com';

// Ruta → prefixul cheilor de traducere. `noindex` ține în afara căutării
// paginile care încă nu au ce spune.
const PAGES = {
  '/': { key: 'seo.home' },
  '/about': { key: 'seo.about' },
  '/services': { key: 'seo.services' },
  '/faq': { key: 'seo.faq' },
  '/contact': { key: 'seo.contact' },
  '/projects': { key: 'seo.projects', noindex: true },
};

// O adresă greșită nu are voie să ajungă în index — altfel Google ajunge să
// listeze pagini de eroare sub numele firmei.
const NOT_FOUND = { key: 'seo.notFound', noindex: true };

export const seoFor = (pathname) => PAGES[pathname] || NOT_FOUND;

export const isKnownRoute = (pathname) => Boolean(PAGES[pathname]);
